
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.707 12.797c0-1.526.325-3.023.975-4.492.65-1.469 1.399-2.655 2.244-3.56a18.32 18.32 0 012.732-2.542c1.04-.79 1.821-1.327 2.341-1.61.52-.282.879-.48 1.074-.593l2.634 2.373c-.39.282-.878.706-1.464 1.271-.715.735-1.43 1.667-2.146 2.797-.91 1.3-1.3 2.457-1.17 3.474 1.43.17 2.634.735 3.61 1.695C27.511 12.57 28 13.7 28 15c0 1.412-.586 2.599-1.757 3.56-1.105.96-2.471 1.44-4.097 1.44-1.886 0-3.447-.65-4.683-1.95-1.17-1.355-1.756-3.107-1.756-5.253zM0 12.797c0-1.526.325-3.023.975-4.492.65-1.469 1.398-2.655 2.244-3.56a18.317 18.317 0 012.732-2.542C6.99 1.413 7.77.876 8.292.593 8.812.311 9.17.113 9.365 0L12 2.373c-.39.282-.878.706-1.463 1.271-.715.735-1.43 1.667-2.146 2.797-.91 1.3-1.301 2.457-1.171 3.474 1.43.17 2.634.735 3.61 1.695.975.96 1.463 2.09 1.463 3.39 0 1.412-.585 2.599-1.756 3.56C9.43 19.52 8.065 20 6.44 20c-1.887 0-3.448-.65-4.683-1.95C.585 16.696 0 14.944 0 12.798z","fill":"#56BFC7"}})])
          )
        }
      }
    